import { useThemeTokens } from '@providers/themeTokenProvider';

export type TabNavTokens = {
  tabNav: {
    borderRadius?: string;
    active?: string;
    height?: string;
    width?: string;
    padding?: string;
    background?: {
      active?: string;
      default?: string;
      hover?: string;
    };
    text?: {
      active?: string;
      default?: string;
      hover?: string;
    };
  };
};

export const useTabNavTokens = (): TabNavTokens => {
  const baseTokens = useThemeTokens();
  const { sys } = baseTokens;
  const comp: TabNavTokens = {
    tabNav: {
      active: sys.color.primary,
      borderRadius: sys.borderRadius.md,
      height: 'auto',
      width: 'auto',
      padding: sys.spacing.md,
      background: {
        active: sys.color.primaryVariant,
        default: sys.color.surfaceContainerVariant,
        hover: sys.color.primaryVariantHover,
      },
      text: {
        active: sys.color.onSurface,
        default: sys.color.onSurface,
        hover: sys.color.onSurface,
      },
    },
  };

  return comp;
};
